<template>
  <div class="ds-open-login-page-box">
    <div class="ds-open-login">
      <!-- 左上角logo -->
      <div class="datastory-logo">
        <img src="https://mtrcdn.datastory.com.cn/ds-open-portal/loginPageLeftTopLogo.svg" alt="logo" @error="imgError">
      </div>
      <div class="ds-open-login__left-box">
        <div style="height: 12.5vh; min-height: 92px" />
        <div class="title-box">
          <p class="title-box__top">
            {{ title }}
          </p>
          <span v-for="(item, index) in contents" :key="item" class="title-box__content">
            <span style="margin: 0 10px;">{{ index !== 0 ? '/' : '' }}</span>
            {{ item }}
          </span>
        </div>
        <div class="main-img">
          <img :src="mainImg" alt="背景图">
        </div>
        <p class="ds-open-login__bottom">
          Copyright © {{ year }} 广州数说故事信息科技有限公司 All Rights
          Reserved 版权所有 备案号：
          <a href="https://beian.miit.gov.cn/" target="_blank" style="color:#222;text-decoration:none">
            粤ICP备15073179号
          </a>
        </p>
      </div>
      <div class="ds-open-login-page">
        <img
          class="box-header__logo hostname-middle-logo"
          :src="loginPageMiddleLogo"
          alt="LOGO"
          @error="imgError"
        >

        <form class="ds-open-login-page__container">
          <div class="ds-open-login-page__form-item">
            <input
              v-model="username"
              type="text"
              class="ds-open-login-page__form-input"
              :placeholder="'请输入账号'"
              autocomplete="off"
              @keydown.enter="login"
            >
            <!-- TODO: 目前icon还依赖ds-views，使用时需引入ds-views才能正常显示 -->
            <i class="ds-open-login-page__form-icon ds-icon-newzhanghao" />
          </div>
          <div class="ds-open-login-page__form-item">
            <input
              v-model="password"
              :type="isShowPassword ? 'text' : 'password'"
              class="ds-open-login-page__form-input"
              :placeholder="'请输入密码'"
              autocomplete="off"
              @keydown.enter="login"
            >
            <i class="ds-open-login-page__form-icon ds-icon-newmima" />
            <i
              v-if="isShowPassword"
              class="ds-open-login-page__mima ds-icon-display-line"
              @click="changeIcon"
            />
            <i
              v-else
              class="ds-open-login-page__mima ds-icon-huaban"
              @click="changeIcon"
            />
          </div>
          <div
            class="ds-open-login-page__error-msg"
            :class="{ show: errorMsg }"
          >
            <i class="ds-open-login-page__error-icon ds-icon-mentionsolid" />
            <span>{{ errorMsg }}</span>
          </div>
          <button
            class="ds-open-login-page__login-btn"
            type="button"
            :class="{ logging }"
            @click="login"
          >
            {{ logging ? '' : '登录' }}
            <svg
              v-if="logging"
              class="ds-open-login-page__login-btn-loading"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 14 14"
            >
              <g id="loading" transform="translate(-18 -8)">
                <rect width="1.077" height="5.385" rx="0.538" transform="translate(24.461 8)" />
                <rect
                  width="1.077"
                  height="5.385"
                  rx="0.538"
                  transform="matrix(0.707, -0.707, 0.707, 0.707, 19.669, 10.431)"
                />
                <rect width="1.077" height="5.385" rx="0.538" transform="translate(18 15.538) rotate(-90)" />
                <rect width="1.077" height="5.385" rx="0.538" transform="translate(20.431 20.331) rotate(-135)" />
                <rect width="1.077" height="5.385" rx="0.538" transform="translate(25.538 22) rotate(-180)" />
                <rect width="1.077" height="5.385" rx="0.538" transform="translate(30.331 19.569) rotate(135)" />
                <rect width="1.077" height="5.385" rx="0.538" transform="translate(32 14.462) rotate(90)" />
                <rect width="1.077" height="5.385" rx="0.538" transform="translate(29.569 9.67) rotate(45)" />
              </g>
            </svg>
          </button>
          <div class="ds-open-login-page__tips">
            <ds-checkbox v-model="agreementChecked" class="ds-open-login-page__agreement">
              <span class="ds-open-login-page__agreement-label">
                已阅读并同意
                <a
                  :href="agreementUrl"
                  target="_blank"
                  class="ds-open-login-page__agreement-link"
                >用户协议</a>
              </span>
            </ds-checkbox>
            <span class="ds-open-login-page__register" @click="registerClick">{{ '立即注册' }}</span>
            <span class="ds-open-login-page__forgot-password" @click="onForgetPassWord">{{ '忘记密码' }}?</span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import storeLogo from '../assets/headerLogo.png'
import { IS_PRODUCTION } from '@/common/variables'
import { encryptPassword } from '@/util/encryption'

export default {
  name: 'DsOpenLogin',
  data() {
    console.log('process.env.NODE_ENV', process.env.NODE_ENV)
    return {
      username: '',
      password: '',
      logging: false,
      errorMsg: '',
      year: 2018,
      isShowPassword: false,
      redirectUrl: '',
      appName: '',
      mainImg: '',
      loginPageMiddleLogo: '',
      title: '',
      contents: [],
      agreementChecked: true,
      agreementUrl: process.env.NODE_ENV === 'development' || location.hostname.includes('.dev.')
        ? 'http://docs.dev.datastory.com.cn/standalone/docs/1572'
        : 'https://docs.datastory.com.cn/standalone/docs/1572'
    }
  },
  async beforeRouteEnter(to, from, next) {
    try {
      const {
        redirect_url: redirectUrl,
        app_name: appName,
      } = to.query
      const json = {
        'mainImg': 'https://opencdn.datastory.com.cn/login-images/main_new.png',
        'loginPageMiddleLogo': storeLogo,
        'title': '数说应用市场',
        'contents': [
          '一站式大数据及AI智能应用',
          '您身边的数据超市',
        ]
      }
      next(vm => {
        vm.appName = appName
        vm.redirectUrl = redirectUrl
        vm.mainImg = json.mainImg
        vm.loginPageMiddleLogo = json.loginPageMiddleLogo
        vm.title = json.title
        vm.contents = json.contents
      })
    } catch (err) {
      next()
    }
  },
  mounted() {
    this.year = new Date().getFullYear()
  },
  methods: {
    imgError(event) {
      event.target.classList.add('error')
      event.target.οnerrοr = null
    },
    async login() {
      if (IS_PRODUCTION && window.collectEvent) {
        window.collectEvent('login_click', {
          login_click_url: window.location.href
        })
      }
      if (!this.username.trim()) {
        this.errorMsg = '邮箱不能为空'
        return
      }
      if (!this.password.trim()) {
        this.errorMsg = '密码不能为空'
        return
      }
      if (!this.agreementChecked) {
        this.errorMsg = '请阅读并同意用户协议'
        return
      }
      if (!this.logging) {
        this.errorMsg = ''
        this.logging = true

        const password = await encryptPassword(this, this.password)
        const { success, message } = await this.$ucProxy({
          url: '/user/login',
          type: 'POST',
          data: {
            username: this.username,
            password,
          },
        }, {
          showMeg: false
        })

        this.logging = false
        if (!success) {
          this.errorMsg = message
        } else {
          if (IS_PRODUCTION && window.collectEvent) {
            window.collectEvent('login_success', {
              login_success_url: this.redirectUrl
            })
          }
          this.$store.commit('RESET_SESSION')
          if (this.redirectUrl) {
            location.replace(this.redirectUrl)
          } else {
            this.$router.push({ name: 'Home' })
          }
        }
      }
    },
    registerClick() {
      const { redirect_url } = this.$route.query
      this.$router.push({
        path: '/o/register/submit',
        query: {
          redirect_url,
        }
      })
    },
    onForgetPassWord() {
      this.$router.push({
        name: 'ResetPassword',
        query: {
          email: this.username,
          redirect_url: this.redirectUrl
        }
      })
    },
    changeIcon() {
      this.isShowPassword = !this.isShowPassword
    },
  }
}
</script>

<style lang="less">
@btn-color: #00bcbe;
@font-color: #fff;
@input-bg: #fff;
@input-color: #333;

.ds-open-login-page-box {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.ds-open-login {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  display: flex;
  align-items: center;
  min-width: 1280px;
  min-height: 720px;
  overflow: hidden;

  img.error {
    display: none;
  }

  .hostname-middle-logo {
    height: 42px;
    margin-bottom: 40px;
  }

  &__left-box {
    position: relative;
    flex: 1;
    height: 100%;
    // padding-top: 12.5vh;
    box-sizing: border-box;
    background-size: cover;
    background-image: url(https://opencdn.datastory.com.cn/login-images/bg.png);

    img {
      // width: 54.17vw;
      height: 58.5vh;
      min-height: 421px;
    }

    .title-box {
      color: #222222;
      text-align: center;
      margin-bottom: 4.6vh;
      @media screen and (max-height: 750px) {
        margin-bottom: 34px;
      }

      &__top {
        font-size: 2.6vw;
        font-weight: 550;
        margin-bottom: 1.1vh;
        margin-top: 0;
        @media screen and (max-width: 1280px) {
          font-size: 33px;
        }
        @media screen and (max-height: 750px) {
          margin-bottom: 8px;
        }
      }

      &__content {
        font-size: 0.83vw;
        line-height: 2.7vh;
        opacity: 0.9;
        height: 2.7vh;
        margin: 0;
        @media screen and (max-height: 750px) {
          height: 20px;
          line-height: 20px;
        }
        @media screen and (max-width: 1690px) {
          font-size: 14px;
        }

        .ds-icon-tagsuccess {
          color: #00ccce;
        }
      }
    }

    .main-img {
      width: 100%;
      display: flex;
      justify-content: center;
    }
  }

  &__bottom {
    width: 100%;
    font-size: 12px;
    color: #222222;
    opacity: 0.6;
    position: absolute;
    bottom: 2.78vh;
    left: 50%;
    transform: translate(-50%, 0);
    margin: 0;
    text-align: center;
  }
}

.datastory-logo {
  position: absolute;
  z-index: 1;
  width: 160px;
  height: 40px;
  top: 40px;
  left: 60px;

  img {
    width: 100%;
    height: 100%;
  }
}

.ds-open-login-page {
  --ds-radio-checkbox--checked-main-color: @btn-color;
  width: 550px;
  height: 100%;
  background-color: #ffffff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__logo {
    top: 50%;
    margin-bottom: 60px;
    max-width: 528px;
    min-width: 383px;
    width: 27.5vw;
  }

  &__container {
    width: 340px;
  }

  &__form-item {
    position: relative;
    width: 100%;
    margin-top: 24px;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.05);

    &:first-child {
      margin-top: 0;
    }
  }

  &__form-input {
    height: 48px;
    width: 100%;
    outline: 0;
    color: @input-color;
    font-size: 16px;
    font-weight: normal;
    padding: 8px 50px 8px 42px;
    border-radius: 4px;
    box-sizing: border-box;
    border: 1px solid #d5d5d5;
    background-color: @input-bg;

    &:focus {
      outline: 0;
      box-shadow: none;
    }

    &:hover,
    &:focus,
    &:active {
      border-color: var(--login-custom-theme-color, #00bcbe);

      & + i {
        color: var(--login-custom-theme-color, #00bcbe);
      }
    }

    &::-webkit-input-placeholder {
      color: #aaaaaa;
      font-weight: normal;
      font-size: 16px;
      letter-spacing: 0px;
    }

    &:-webkit-autofill {
      -webkit-text-fill-color: @input-color;
      font-weight: normal;
      -webkit-box-shadow: 0 0 0 1000px #fff inset;
    }

    &:-internal-autofill-selected {
      color: @input-color;
      background-color: @input-bg !important;
    }
  }

  input[type="password"] {
    letter-spacing: 4px;
    color: #333333;
  }

  &__form-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #999999;
    font-size: 20px;
  }

  &__mima {
    font-size: 16px;
    color: #999999;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 12px;
    cursor: pointer;

    &:hover {
      color: #00bcbe;
    }
  }

  &__error-msg {
    font-size: 14px;
    color: #ec2a1d;
    height: 48px;
    line-height: 48px;
    text-align: left;
    opacity: 0;
    display: flex;
    align-items: center;

    &.show {
      opacity: 1;
    }

    span {
      height: 100%;
    }
  }

  &__error-icon {
    margin-right: 2px;
    font-size: 14px;
  }

  &__login-btn {
    width: 100%;
    border-radius: 5px;
    background-color: #00bcbe;
    border: 1px solid @btn-color;
    color: @font-color;
    letter-spacing: 2px;
    font-size: 20px;
    text-align: center;
    height: 48px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    line-height: 1;
    white-space: nowrap;
    outline: 0;
    margin: 0;
    font-weight: 500;

    &:hover,
    &:focus {
      background-color: #6eced2;
      color: @font-color;
      border-color: #6eced2;
    }

    .ds-button__loading-mask {
      background-color: #6eced2;
    }

    &.logging {
      cursor: not-allowed;
      background-color: #6eced2;
      border-color: #6eced2;
    }
  }

  @keyframes rotating {
    0% {
      transform: rotateZ(0deg);
    }
    100% {
      transform: rotateZ(360deg);
    }
  }

  &__login-btn-loading {
    fill: #fff;
    animation: rotating 2s linear infinite;
    font-size: 16px;
    transition: color .15s linear;
  }

  &__tips {
    display: flex;
    align-content: center;
    font-size: 14px;
    color: #666;
    padding-top: 19px;

    .ds-open-login-page__register, .ds-open-login-page__forgot-password {
      &:hover,
      &:focus {
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  &__agreement {
    margin-top: 2px;
  }

  &__agreement-label {
    font-size: 14px;
  }

  &__agreement-link {
    color: @btn-color;
    text-decoration: none;
  }

  &__register {
    position: relative;
    margin-right: 16px;
    margin-left: auto;

    &:after {
      position: absolute;
      top: 2px;
      right: -8px;
      content: '';
      height: 14px;
      border-right: 1px solid #707070;
    }
  }
}

.dynamic-bg-layer {
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .datastory-bg-logo {
    width: 100%;
    height: auto;
  }
}
</style>
